<template>
    <q-page class="flex flex-center">
      <!--  -->
<div class="q-pa-md ">
      <div class="row row justify-center" v-if="accountCreationAlert === true" style="margin-bottom:25px">
         <q-card class="my-card" style="max-width:70%;">
            <q-card-section  class=" text-white text-h6">
              <div class="row justify-between">
                <div class="col">
                      Hi {{StoreStateAOD.PersonalInformation.FullName}},
                </div>
                <div class="col-1">
                  <q-btn color="white" round flat dense :icon="expanded ? 'keyboard_arrow_up' : 'keyboard_arrow_down'" @click="expanded = !expanded" value="" ></q-btn>  
                </div>    
              </div>
            </q-card-section>
                <q-form class="q-gutter-md" v-show="expanded">
                    <q-card-section>
                         <q-banner  rounded>
                          
                            <template class="column items-center" v-slot:avatar>
                               <div class="col-12 col-md-6 ">
                            <!--    ../assets/user.png -->
                                  <img src="../assets/img/email.png" style="width: 100px; height: 100px">
                                  </div>
                              </template>
                           
                           
                            <div class="row justify-center" >
                                <div class="col-12 col-md-12  self-center ">
                                    <div class="text-h6 ">
                                        <u>
                                            {{$t("common.account_1")}}
                                        </u>
                                    </div>
                                </div>
                            </div>
                            <div class="row justify-center" >
                                <div class="col-12 col-md-12  justify-center">
                                    <div class="text-body1">
                                        {{$t("common.account_2")}}  <b>{{StoreStateAOD.ContactInformation.EmailAddress}}</b> {{$t("common.account_3")}} <b>{{$t("common.account_4")}}</b>
                                    </div>
                                </div>
                            </div> 
                            <div class="column items-end" >
                              <div class="col-1">
                                <q-btn color="primary" @click="expanded = !expanded" label="OK, Got It" />
                              </div>
                            </div> 
                        </q-banner> 
                    </q-card-section> 
            </q-form>
            </q-card>
          </div>


          <div class="column items-center"> 
            <div class="col">
        <!-- <transition-group   appear :duration="{ enter: 1500, leave: 800 }" enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" class="group"> -->
          <q-card key="brand" inline style="font-family: 'Poppins', sans-serif; background-color: #fff; border-radius: 1rem; border: 1px solid white; " class="flex flex-center q-pa-lg">
                <div class="column">
                  <!-- <img id="logo" src="https://nadiablob.blob.core.windows.net/assets/aham-logo-bw-transparentbg.png" alt="logo"/> -->
                <q-card-section>
                  
                    <div class="text-h6 text-center text-bold">Login to Your Account</div>
                    <!-- <div class="q-caption text-center">i-ACCESS MEMBER LOGIN</div> -->
                </q-card-section>
                <q-card-section>
                    <q-form @submit="onSubmit" @firsttimelogin="onFirstTimer" class="">
                        <div class="row">
                            <div class="col">
                              Username
                                <q-input bg-color="white" rounded outlined key="text" 
                                v-model="userID" ref="Username" :rules="[val => !!val || 'Username is required']"
                                style="">
                                    <template v-slot:prepend>
                                        <q-icon name="far fa-user-circle"/>
                                    </template>
                                </q-input>
                            </div>
                            
                        </div>
                        
                      <div class="row justify-center q-mt-md" style="">
                                <!-- <a @click="toResetPage" id="forgotPassword" style="cursor: pointer; color: #355dc4;"><u>Forgot Username/Password?</u></a> -->
                          
                        </div>
                        <div class="row">
                            <div class="col q-pt-md">
                                <q-btn
                                  unelevated
                                  size="lg"
                                  :loading="submitting"
                                  label="Next"
                                  type="submit" 
                                  class="" 
                                  style="width: 100%; background: #ff6666; color: white; border-radius: 0.5rem;">
                                </q-btn>
                            </div>
                        </div>
                       
                    </q-form>
                   <!--  <div class="row">
                        <div class="col q-pt-md">
                            <q-btn rounded style="width:100%; margin-top:10px" @click="toResetPage" label="Forgot User ID / Password" type="forgotpassword" color="warning"></q-btn>
                        </div>
                    </div> -->
                </q-card-section>
                </div>
            </q-card>
        <!-- </transition-group> -->
        </div>
          </div>
</div>
        <q-dialog v-model="requestUpdatePassword"  persistent transition-show="scale" transition-hide="scale">
         <q-card class="my-card" >
            <q-card-section  class="bg-primary text-white text-h6">
               <div class="row justify-between">
                  <div class="col">
                    Forgot Username/Password?
                  </div>
               </div>
            </q-card-section>
            <q-form   class="q-gutter-sm" @submit="updateUserPassword"  @reset="closePopUp" >
               <q-card-section>
                <div class="row" >


                  <q-input outlined v-model="StoreStateAOD.loginUserName" class="self-center text-body1 col-sm-12 col-md-12 col-xs-12 text-bold investmentInfo" lazy-rulesss  :rules="[val => !!val || 'Required', isValidEmail]"   label='Username' >
                    <template v-slot:prepend>
                      <q-icon name="fas fa-user" color="primary"/>
                    </template>
                  </q-input>

                  <q-input outlined  v-model="StoreStateAOD.loginPassWord" :type="isPwd ? 'password' : 'text'" class="self-center text-body1 col-sm-12 col-md-12 col-xs-12 text-bold investmentInfo"  lazy-rulesss :rules="[val => !!val || 'Required ', isStrongPassword]"  label='Password' >
                    <template v-slot:prepend>
                      <q-icon name="lock" color="primary"/>
                    </template>
                       <template v-slot:append>
                        <q-icon
                            :name="isPwd ? 'visibility_off' : 'visibility'"
                            class="cursor-pointer"
                            @click="isPwd = !isPwd"
                        />
                        </template>
                  </q-input>                 
                </div>
                <div v-if="showTacComponent===true">
                   <Tac
                     :customerId=tacID
                     :idType=tacIDTYPE
                     :purpose=tacPurpose
                     :validityInMinutes= 3
                     :env=tacEnv
                     :apiUrl=tacapiUrl
                     :notificationAPIToken=tacnotificationAPIToken
                     :cifAPIToken=taccifAPIToken   
                     @submit="submitTAC"
                     @cancel="cancelTAC"
                     /> 
                  </div>
               </q-card-section>
               <q-card-actions align="right" >
                  <q-btn label="cancel" color="red" text-color="white" type="reset"/>
                  <q-btn label="Update" color="primary" text-color="white" type="submit" :disable='TacisVerified' />
               </q-card-actions>
            </q-form>
         </q-card>
      </q-dialog>
    <!--   <q-dialog v-model="requestUpdateAlert"  persistent transition-show="scale" transition-hide="scale">
        <q-card class="my-card" style="max-width:30vw">
        <q-card-section  class="bg-warning text-white text-body1">
                Hi {{StoreStateAOD.PersonalInformation.FullName}},
        </q-card-section>
            <q-form   class="q-gutter-md" @submit="onUpdateInfo">
                <q-card-section>
                    <UpdateRequest/>  
                </q-card-section>

        <q-card-actions align="right" >
            <q-btn label="Update" color="primary" text-color="white" type="submit" />
        </q-card-actions>
        </q-form>
        </q-card>
    </q-dialog> -->

  </q-page>
</template>
<style>
#logo {
    max-width: 220px !important;
    max-height: 115px !important;
    margin: auto;
    image-rendering: -webkit-optimize-contrast;
}

#forgotPassword:hover{
  color: blue;
}
p.text-h5 {
  display: none;
}
</style>

<script>
import { mapState, mapActions } from "vuex";
import store from '../store';
import Tac from '../components/tac/Tac.vue';

import UpdateRequest from '@/components/UpdateRequest.vue'
export default {
    name : 'LoginScreen',
   components : {
        UpdateRequest,
        Tac
    },
  data() {
    return {
      ////buy?appId=e93b4b9b-3ef3-487d-84fb-e572e398fc01&language=EN
      tacID:store.state.AOD.PersonalInformation.NRIC,
      tacIDTYPE:'NRIC',
      tacPurpose:'EPF I-Invest - iAccess Request for Password Reset',
      tacEnv:process.env.NODE_ENV,
      tacapiUrl:process.env.VUE_APP_APICONNECT,
      tacnotificationAPIToken:store.state.API.NotificationAPIToken,
      taccifAPIToken:store.state.API.CIFAPIToken,
      TacisVerified:true,
      showTacComponent:true,
      slide: 1,
      userID: null,      
      dense: false,
      submitting: false,
      isIEBrowser: false,
      BrowserType:'',
      StoreStateAOD: store.state.AOD, 
      StoreStateLogin: store.state.Login,
      StoreStateAD: store.state.AD,
      StoreStateCD : store.state.CD,
      requestUpdateAlert:false,
      accountCreationAlert:false,
      expanded: true,
      requestUpdatePassword:false,
      isPwd: true,
    };
  },
  computed: {
    ...mapState({
      IsSuccessful: state => state.Login.IsSuccessful,
      UserName: state => state.Login.UserName
    })
  }, created() {
     var ua = window.navigator.userAgent; 
        var msie = ua.indexOf('MSIE '); 
        if (msie > 0) { 
          this.isIEBrowser = true;
            // IE 10 or older, return version number 
          this.BrowserType  = 'IE ' + parseInt(ua.substring( msie + 5, ua.indexOf('.', msie)), 10)
        } 
        var trident = ua.indexOf('Trident/'); 
        if (trident > 0) { 
            // IE 11, return version number 
          this.isIEBrowser = true;
          var rv = ua.indexOf('rv:'); 
          this.BrowserType ='IE ' + parseInt(ua.substring(   rv + 3, ua.indexOf('.', rv)), 10)
            
        } 
        var edge = ua.indexOf('Edge/'); 
        if (edge > 0) { 
          
            //Edge (IE 12+), return version number 
           this.isIEBrowser = true;
           this.BrowserType = 'IE ' + parseInt(ua.substring(   edge + 5, ua.indexOf('.', edge)), 10)
        }

      if(this.isIEBrowser === false){
       store.commit('ResetToken')
      }else{
         this.$q.dialog({
              title: 'Alert',
              message: "Hi, Our application is not supported in : "+this.BrowserType+". Best use in Google Chrome or Mozilla Firefox. You may continue by Copy and Paste the URL: https://investdev.affinhwangam.com" +
              this.StoreStateLogin.RouteToPath+" in Google Chrome or Mozilla Firefox"
          }).onOk(() => {
              this.triggerLogout();
          })   
     }
  },
    mounted(){
        this.$store.dispatch('Logging',{
            appid : '2',
            typeid :'4', 
            str : 'Login Page--> ' + this.StoreStateLogin.TransactionData
        });

   this.$refs.Username.$el.focus()
     /*  if(this.StoreStateAD.LoginAccountType === "T"){
     
           this.$q.loading.show({
                    spinnerSize: 50
                  })
          this.$store.dispatch('getExistingInvestorUTAccount').then(res=>{
                  this.accountCreationAlert = true;
                  this.$q.loading.hide() 
          })

      }else{
          if((this.StoreStateAD.hasLoginCredential === false)&&(this.StoreStateAD.LoginAccountType === "")){
            
          this.$store.dispatch('getExistingInvestorUTAccount').then(res=>{
            if(res === true){
                if((this.StoreStateAOD.ContactInformation.MobileNo === '') || (this.StoreStateAOD.ContactInformation.EmailAddress === '')){

                 this.requestUpdateAlert = true;
                }else{ 
                  this.accountCreationAlert = true;
                  this.$q.loading.show({
                    spinnerSize: 50
                  })

                this.TriggerAccountCreation({
                    ApplicationId :this.StoreStateAOD.PersonalInformation.NRIC,
                    firstTimeLoginInfo : this.StoreStateLogin.TransactionData
                  }).then(res=>{  

                    this.$store.dispatch('Logging',{
                          appid : '2',
                          typeid :'4', 
                          str : 'Application ID --> ' + this.StoreStateLogin.incomingAppID + ' TriggerAccountCreation (login),  res - > '+  res +' -  ' + this.StoreStateAOD.PersonalInformation.NRIC
                      }); 
                    
                    this.$q.loading.hide()
                  }) 
              }  
            }else{
              alert(res)
            }
              
                
          })
        }else{
          this.accountCreationAlert = false;
        }
      }  */
     
      
    },
  methods: {
    ...mapActions([
      "GetLoginDetails",
      "triggerLogout",
      "TriggerAccountCreation",            
      "CIFAccountInformationUpdate",
      "UpdateIAccessUsernamePassword"
    ]),

    isValidEmail:function (val) {
        const emailPattern = /^(?=[a-zA-Z0-9@._%+-]{6,254}$)[a-zA-Z0-9._%+-]{1,64}@(?:[a-zA-Z0-9-]{1,63}\.){1,8}[a-zA-Z]{2,63}$/;
        return emailPattern.test(val) || 'Invalid email';
        },

    isStrongPassword:function(val){
            const strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})");
            return strongRegex.test(val) || 'Make sure to have special Characters !@#\$%\^&\ ,Alphanumeric and Upper Caps. Min 8 Chars';
        },
     submitTAC (payload){
        if(payload.isVerified === true){
          this.TacisVerified = false
          this.$q.notify({
            message:'TAC VERIFIED, Click on UPDATE button to proceed' ,
            color: 'green'
          })
        }else{
          this.TacisVerified = true
          this.$q.notify({
            message:'INVALID TAC' ,
            color: 'red'
          })
        }
      },
      cancelTAC(payload) {
        this.TacisVerified = true
        this.requestUpdatePassword = false
      },
     /* onUpdateInfo(){
            this.$q.loading.show({
                spinnerSize: 50
            }), 
            this.CIFAccountInformationUpdate()
            .then(res => {
              
                this.$store.dispatch('Logging',{
                      appid : '2',
                      typeid :'4', 
                      str : 'Application ID --> ' + this.StoreStateLogin.incomingAppID + ' CIFAccountInformationUpdate (login),  res - > '+  res +' - CustomerId -> ' + this.StoreStateCD.CustomerDetails.CustomerId +' -  NRIC ->' + this.StoreStateAOD.PersonalInformation.NRIC + ' -  MobileNo ->' + this.StoreStateAOD.ContactInformation.MobileNo+ ' -  EmailAddress ->' + this.StoreStateAOD.ContactInformation.EmailAddress
                  }); 
                if(res == true){
                    this.accountCreationAlert = true;
                    this.requestUpdateAlert = false;
                    this.TriggerAccountCreation({
                        ApplicationId :this.StoreStateAOD.PersonalInformation.NRIC,
                        firstTimeLoginInfo : this.StoreStateLogin.TransactionData
                    }).then(res=>{
                      
                      this.$store.dispatch('Logging',{
                          appid : '2',
                          typeid :'4', 
                          str : 'Application ID --> ' + this.StoreStateLogin.incomingAppID + ' TriggerAccountCreation after cIF update (login),  res - > '+  res +' -  ' + this.StoreStateAOD.PersonalInformation.NRIC
                      }); 
                    })
                    this.$q.loading.hide()
                }else{
                this.$q.dialog({
                    title: 'Error',
                    message: 'Sorry, unable to update your info. Please contact our Customer Support to assist you on this'
                })
                this.$q.loading.hide()
                }

            })
        }, */

    onSubmit () {
        this.submitting = true
      if (this.userID) {
      
        //go to next page, while routing to there function to check id exist or not
          this.GetLoginDetails(this.userID).then((returnVal) => {
        // other validations here
        //  save
        this.submitting = false
       //   console.log(this.IsSuccessful)
           this.$router.push({
            name: "AHAM Login Checking",
            params: { params: { IsSuccessful:true } }
            //this.IsSuccessful 
          });  
        })        
          
      }
      else {
        //TODO: return error message userID needed
      
      }
    },
    toResetPage() {
      this.StoreStateAOD.loginPassWord=''
      this.requestUpdatePassword = true  
      this.TacisVerified = true
    },
     updateUserPassword(){
      
      this.$q.loading.show({
          spinnerSize: 50
      }),
     this.UpdateIAccessUsernamePassword()
            .then( async res=>{
              
                this.$q.loading.hide()
                if(res===true){
                  
                    this.$q.dialog({
                      title : 'Success',
                      message : 'Your password is updated, you may login using the latest credential.'
                    }).onOk(() => {
                     //this.$router.push({ name: "AHAM Login"});
                    })
                }else if(res===false){
                    this.$q.dialog({
                      title : 'Sorry',
                      message : 'Sorry, something went wrong. Please retry the process.'
                    })
                    .onOk(() => {
                       // this.$router.push({ name: "AHAM Login"});
                    })
                    
                }else {
                     this.$q.dialog({
                        title : 'Sorry',
                        message : 'Error: ' + res
                    }) 
                    .onOk(() => {
                      //  this.$router.push({ name: "AHAM Login"});
                    })
                }
            })
      this.requestUpdatePassword = false
      //this.closePopUp();
    }, 

    closePopUp(){
      this.requestUpdatePassword = false
    },
    onFirstTimer() {
      //TODO: Route back to iAccess page to ask them complete first timer login, end the session

    }
  }
};
</script>

<style>
.userID>.q-field>.q-field__inner >.q-field__control >.q-field__prepend,
.userID>.q-field>.q-field__inner >.q-field__control >.q-field__control-container>.q-field__label,
.userID>.q-field>.q-field__inner >.q-field__control >.q-field__control-container> .q-field__native {
  color:black
}

</style>